// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ellipsis"},"children":[{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M4 11.5H5V12.5H4V11.5Z M11.5 11.5H12.5V12.5H11.5V11.5Z M19 11.5H20V12.5H19V11.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const EllipsisIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ellipsis',
    ref,
    icon: element,
  },
));

EllipsisIcon.displayName = 'EllipsisIcon';

export default EllipsisIcon;
